import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { captureException } from '@sentry/react';
import { useCallback, useEffect, useMemo } from 'react';
import { useTimeoutFn } from 'react-use';

export interface UseSplashScreenHiderValue {
  /**
   * Allows manually invoking hide, e.g due to app finished loading
   * faster than expected
   */
  hideSplashScreen(): void;
}

/**
 * Automatically hides the splash screen taking platform into account.
 */
export const useSplashScreenHider = () => {
  const isIos = Capacitor.getPlatform() === 'ios';

  const hideSplashScreen = useCallback(() => {
    SplashScreen.hide().catch((error) => {
      console.error(error);
      captureException(error);
    });
  }, []);

  useTimeoutFn(() => {
    if (isIos) {
      hideSplashScreen();
    }
  }, APP_CONFIG.app.splashDelay);

  useEffect(() => {
    if (!isIos) {
      hideSplashScreen();
    }
  }, [isIos]);

  return useMemo(
    () => ({
      hideSplashScreen,
    }),
    [hideSplashScreen],
  );
};
